import styled from 'styled-components'
import { CloseRoundIcon, SearchIcon, SwitchCurveIcon } from '~/components/icons'
import { ReactComponent as Q } from './assets/q.svg'

export const StyledTokenListContainer = styled.div`
  display: flex;
  flex-direction: column;
  overflow: hidden auto;
  margin: -22px -1rem 0;
  min-height: 70vh;
  max-height: 70vh;
`

export const SearchInput = styled.input`
  border: 0.5px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 42px;
  padding: 12px 10px 12px 33px;
  padding-right: 35px;
  background: transparent;
  font-size: 13px;
  line-height: 16px;
  width: 100%;
  outline: none;
  background: ${({ theme }) => theme.colors.bgSurface};

  &:focus,
  &:hover {
    box-shadow: 0 0 2px rgba(95, 77, 188, 0.2);
  }
`
export const StyledTokenSearch = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  padding: 0 10px 15px;
  background: ${({ theme }) => theme.colors.bgCard};
`
export const SearchInputLeftIcon = styled(SearchIcon)`
  position: absolute;
  left: 21px;
  top: 11px;
`

export const SearchInputRightIcon = styled(CloseRoundIcon)`
  position: absolute;
  right: 21px;
  top: 11px;
  cursor: pointer;
`

export const StyledTokenList = styled.div`
  padding-left: 16px;
  padding-right: 16px;
`

export const StyledSearchFeedback = styled.div`
  background: #efecff;
  border: 1px solid ${({ theme }) => theme.colors.borderDefault};
  border-radius: 12px;
  padding: 10px;
  font-weight: 400;
  font-size: 13px;
  color: ${({ theme }) => theme.colors.primary};
  position: relative;
  margin-top: 10px;

  &:before {
    content: '';
    position: absolute;
    border: 5px solid ${({ theme }) => theme.colors.borderDefault};
    top: 0;
    left: 35px;
    transform: rotate(45deg) translateY(-50%);
  }
`

export const IconQ = styled(Q)`
  margin-left: 7px;
  margin-right: 7px;
  margin-bottom: -1px;
  display: inline-block;
  width: 14px;
  height: 14px;
  vertical-align: -2.4px;
  cursor: pointer;
`

export const StyledTabWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 17.5px;
`

export const StyledTabLabel = styled.span`
  color: ${({ theme }) => theme.colors.textTitle};
  font-weight: normal;
  font-size: 13px;
  line-height: 24px;
  width: 60px;
  display: inline-block;
  text-align: center;
  position: relative;
  margin-bottom: 10px;
  margin-top: 13px;

  &::after {
    content: '';
    width: 14px;
    height: 2px;
    background: ${({ theme }) => theme.colors.textTitle};
    border-radius: 2px;
    position: absolute;
    bottom: -3px;
    left: 50%;
    transform: translateX(-50%);
  }
`

export const StyledSwitcherWrapper = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  font-size: 13px;
  line-height: 24px;
  color: ${({ theme }) => theme.colors.textTitle};
  cursor: pointer;
  user-select: none;
`

export const StyledIconSwitcher = styled(SwitchCurveIcon)`
  cursor: pointer;
`

export const StyledEmptyResult = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 14px;
  min-height: 40vh;
  color: ${({ theme }) => theme.colors.textTertiary};
  font-size: 13px;
  font-weight: 400;
  line-height: 18px;

  img {
    width: 88px;
    height: 88px;
  }

  div {
    text-align: center;
  }

  p {
    width: 264px;
    margin-bottom: 0;
  }
`

export const StyledAddTokenButton = styled.button`
  background: ${({ theme }) => theme.colors.primary};
  border-radius: 8px;
  padding: 0 16px;
  border: none;
  outline: none;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  color: #ffffff;
  height: 36px;
  cursor: pointer;
`
